import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  container: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    // marginTop: 64,
    alignItems: "center",
    marginBottom: 32,
    padding: "0 72px 0 72px",
    maxWidth: 1000,
    margin: "auto",
    [theme.breakpoints.down("xl")]: {
      padding: "0 32px",
    },
  },

  body: {
    marginTop: -64,
    paddingBottom: 32,
    minHeight: 640,
    background:
      "url(/assets/imgs/bank/bank_bg.png) no-repeat",
    backgroundSize: "100% auto",
    color: "white",

    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "left top",
      backgroundSize: "auto auto",
    },
  },

  header: {
    width: "100%",
    justifyContent: "space-between",
    display: "flex",
    gap: 32,
    marginTop: 80,
    alignItems: "center",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "0 32px",
    },

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: 16,
      marginTop: 60,
      padding: "0 16px",
    },
  },

  headerLeft: {
    display: "flex",
    gap: 16,
    alignItems: "center",

    "& img": {
      width: 32,
    },

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },

  title: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },

  headerRight: {
    display: "flex",
    gap: 16,
    alignItems: "center",
    fontSize: 22,
    fontWeight: 700,
    fontFamily: "Philosopher",

    "& img": {
      width: 32,
    },
  },

  content: {
    display: "grid",
    gridTemplateColumns: "3fr 2fr",
    gap: 16,
    width: "100%",

    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },
  },

  contentLeft: {
    border: "1px solid black",
    backgroundColor: "rgba(28, 30, 31)",
    borderRadius: 16,
    padding: "24px 48px",
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },

  balanceTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Philosopher",
  },

  viewHistory: {
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Philosopher",
    color: "#ffffff50",
    cursor: "pointer",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#ffffff",
      transition: "color 0.3s ease",
    },
  },

  contentRight: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    height: "100%",
    justifyContent: "space-between",


  },

  profileImg: {
    width: "100px",
    borderRadius: 8,

    [theme.breakpoints.down("md")]: {
      width: 64,
    },
  },

  balanceBox: {
    display: "flex",
    gap: 16,
    alignItems: "center",
    border: "1px solid black",
    backgroundColor: "#1c1c1c",
    borderRadius: 16,
    padding: "24px 48px",
    justifyContent: "center",

    "& img": {
      width: 32,
    },

    "&>div": {
      fontWeight: 700,
      fontSize: 22,
      fontFamily: "Philosopher",
    },

    [theme.breakpoints.down("md")]: {
      padding: "16px 8px",
    },
  },

  transferTitle: {
    display: "flex",
    gap: 16,
    alignItems: "center",
    justifyContent: "space-between",
    fontFamily: "Philosopher",
  },

  transferTitleRight: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    color: "#ffffff50",

    "& img": {
      width: 24,
    },

    "& div": {
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
  },

  transferInputBox: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 24,
    alignItems: "center",
    border: "1px solid black",
    backgroundColor: "#1c1c1c",
    borderRadius: 16,
    padding: "24px 48px",

    "& img": {
      width: 24,
    },

    [theme.breakpoints.down("md")]: {
      padding: "16px 8px",
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },
  },

  transferInputBoxLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,

    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },

  transferInputBoxLeftTop: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    borderBottom: "1px solid #333333",
    width: "100%",
  },

  transferInputBoxRight: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "center",
  },

  transferInputBoxRightTop: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    borderBottom: "1px solid #333333",
    width: "100%",
  },

  transferButtonBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  transferButton: {
    backgroundColor: "rgba(55, 176, 128, 1)",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "8px 24px",
    cursor: "pointer",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",
    marginTop: 16,

    "&:disabled": {
      backgroundColor: "rgb(91, 96, 100)",
      cursor: "not-allowed",
    },

    "&:hover": {
      backgroundColor: "rgba(55, 176, 128, 0.8)",
    },
  },

  priceInput: {
    background: "transparent",
    outline: "none",
    border: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "#FFFFFF50",
    fontSize: "16px",
    lineHeight: "28px",
    width: "100%",
  },

  allButton: {
    color: "#01518f",
    fontFamily: "Philosopher",
    fontWeight: 900,
    fontSize: 16,
    textTransform: "none",
    padding: "0 8px",
    minWidth: "fit-content",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 255, 0.1)",
    },
  },

  greyColor: {
    color: "#ffffff50",
    fontFamily: "Philosopher",
  },

  contentRightTop: {
    border: "1px solid black",
    backgroundColor: "rgba(28, 30, 31)",
    borderRadius: 16,
    padding: "24px 32px",
    fontFamily: "Philosopher",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    justifyContent: "center",
    height: "100%",
  },

  clockWise: {
    width: 32,
  },

  remainMin: {
    fontSize: 28,
    fontWeight: 900,
    marginTop: 4,
  },

  remainSec: {
    fontSize: 20,
    fontWeight: 500,
  },

  nextCashTransfer: {
    fontSize: 14,
    color: "#ffffff50",
    marginTop: 16,
  },

  contentRightBottom: {
    border: "1px solid black",
    backgroundColor: "rgba(28, 30, 31)",
    borderRadius: 16,
    padding: "24px 32px",
    display: "flex",
    gap: 16,
    height: "100%",

    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },
  },

  contentRightBottomLeft: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    justifyContent: "center",
    height: "100%",
    fontFamily: "Philosopher",
  },

  contentRightBottomRight: {
    display: "flex",
    gap: 8,
    fontFamily: "Philosopher",
    flexDirection: "column",

    "& p": {
      fontFamily: "Philosopher",
    },

    "&>div": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 8,
    },
  },

  claimButton: {
    backgroundColor: "rgb(40, 127, 209)",
    color: "#fff",
    border: "none",
    borderRadius: "16px",
    padding: "4px 24px",
    cursor: "pointer",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",

    "&:disabled": {
      backgroundColor: "rgb(23, 24, 25)",
      cursor: "not-allowed",
    },
  },
}));

export default styles;
